"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoldBy = void 0;
const react_1 = __importDefault(require("react"));
const themed_text_1 = require("../themed-text");
const styles_1 = require("./styles");
const SoldBy = (props) => {
    return (react_1.default.createElement(themed_text_1.ThemedSpan, { font: 'base' },
        react_1.default.createElement(styles_1.SoldByLabel, { "data-cy": 'sold-by-label' }, props.soldByLabelCopy),
        react_1.default.createElement(styles_1.SoldByValue, { "data-cy": 'sold-by-value' }, props.soldByValue)));
};
exports.SoldBy = SoldBy;
